/**
 * @internal
 */
import React, { useContext } from 'react';
const ButtonMotionContext = React.createContext({
    motion: false,
    active: false,
    hover: false,
    iconAnimation: false,
});
export const ButtonMotionContextProvider = ({ active, hover, children, iconAnimation, }) => {
    const { active: parentActive, hover: parentHover } = useButtonMotion();
    return (React.createElement(ButtonMotionContext.Provider, { value: {
            motion: true,
            active: parentActive || active,
            hover: parentHover || hover,
            iconAnimation,
        } }, children));
};
export const useButtonMotion = () => {
    const { motion, active, hover, iconAnimation } = useContext(ButtonMotionContext);
    if (!iconAnimation) {
        return { active };
    }
    return { motion, active, hover };
};
